import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import FlightsFilters from 'components/FlightsFilters';
import useIsMobile from 'hooks/useIsMobile';
import { Airport } from 'models/airport';
import { FlightFilterResponse, FlightFilter } from 'models/flightFilter';
import { FlightResultRequestOrderCriteriaEnum } from 'models/flightSearch';

interface Props {
  show: boolean;
  orderCriteria: FlightResultRequestOrderCriteriaEnum;
  directFlights: boolean;
  onClose: () => void;
  onChange: (filters: FlightFilter) => void;
  availableFilters?: FlightFilterResponse;
  roundTrip?: boolean;
  baggageIncluded?: boolean;
  cabin?: string;
  departurePoint?: Airport;
  arrivalPoint?: Airport;
  departureDate?: Date;
  returnDate?: Date;
  isLoading: boolean;
  currency: string;
}

const FlightsFilterContainer = ({
  onChange,
  orderCriteria,
  availableFilters,
  isLoading,
  currency,
  ...props
}: Props) => {
  const isMobile = useIsMobile();
  const { defaultFilters } = useSelector((state: RootState) => ({
    search: state.flights.search,
    defaultFilters: state.flights.filters,
  }));

  const handleSearch = async (filters: FlightFilter) => {
    if (isMobile) props.onClose();
    onChange(filters);
  };

  return (
    <FlightsFilters
      {...props}
      onSearch={handleSearch}
      currency={currency || 'COP'}
      defaultFilters={defaultFilters}
      availableFilters={availableFilters}
      isLoading={isLoading}
    />
  );
};

export default FlightsFilterContainer;
